import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/personal-storage-solutions.jpg'),
    alt: 'personal storage solutions page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'personal storage solutions page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Personal <span>Storage</span><span>Solutions Fast And Secure</span>',
  description:
    "Whether you're moving, downsizing, or just need extra space for your belongings, our personal storage solutions provide you with the flexibility and security.",
  image: {
    url: '/images/v2/pages/landing-pages/personal-storage-solutions/hero-image.jpg',
    alt: 'Personal Storage Solutions Fast And Secure'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Your Personal Storage Solution' }
}

export const ourProcessSectionContent = {
  title: 'How Personal Storage Solutions Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/personal-storage-solutions/how-personal-storage-solutions-work.png',
    alt: 'How Personal Storage Solutions Work'
  },

  articles: [
    {
      id: 1,
      title: 'Flexible Storage Options',
      description:
        "Choose from a variety of storage unit sizes to fit your needs, whether it's just a few boxes or the contents of an entire home.",
      image: {
        src: '/images/v2/pages/landing-pages/personal-storage-solutions/flexible-storage-options.png',
        alt: 'Flexible Storage Options'
      }
    },
    {
      id: 2,
      title: 'Convenient Access',
      description:
        'Our personal storage facilities are accessible 7 days a week, allowing you to visit and manage your items at your convenience.',
      image: {
        src: '/images/v2/pages/landing-pages/personal-storage-solutions/convenient-access.png',
        alt: 'Convenient Access'
      }
    },
    {
      id: 3,
      title: 'Secure and Safe',
      description:
        'Your belongings are stored in secure, well-maintained facilities with 24/7 surveillance and top-notch security measures to ensure their safety.',
      image: {
        src: '/images/v2/pages/landing-pages/personal-storage-solutions/secure-and-safe.png',
        alt: 'Secure and Safe'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Personal Storage Services',
  description:
    "Personal storage solutions give you peace of mind by providing a safe and convenient place to store your items. Whether you're in-between homes, need extra space, or just want to declutter, these storage solutions can help you manage your belongings without worry.",
  image: {
    src: '/images/v2/pages/landing-pages/personal-storage-solutions/affordable-personal-storage-services.jpg',
    alt: 'Affordable Personal Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Personal Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'No Long-Term Commitment',
      description:
        'Store your items for as long or as short as you need, with no long-term contracts or extra charges.',
      image: {
        src: '/images/v2/pages/common/no-ong-term-commitment.png',
        alt: 'No Long-Term Commitment'
      }
    },
    {
      id: 2,
      title: 'Variety of Storage Sizes',
      description:
        'From small units for personal items to large units for furniture and appliances, we have the right space for your needs.',
      image: {
        src: '/images/v2/pages/common/free-up-office-space.png',
        alt: 'Variety of Storage Sizes'
      }
    },
    {
      id: 3,
      title: 'Security and Protection',
      description:
        'Your items are safely stored in secure facilities with advanced security systems and climate controls for added protection.',
      image: {
        src: '/images/v2/pages/common/enhanced-security2.png',
        alt: 'Security and Protection'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Personal Storage Solutions?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners',
          description: "Store your seasonal items, furniture, or belongings that don't fit in your home."
        },
        {
          id: 2,
          title: 'Renters',
          description:
            'Need to downsize or store items temporarily? Personal storage solutions give you a secure, accessible option for your belongings.'
        },
        {
          id: 3,
          title: 'Students',
          description: "Store your personal items between semesters or when you're moving in or out of dorms."
        },
        {
          id: 4,
          title: 'People in Transition',
          description:
            "If you're moving between homes, renovating, or temporarily relocating, personal storage gives you a flexible space to store your items."
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/personal-storage-solutions/who-should-use-personal-storage-solutions.jpg',
        alt: 'Who Should Use Personal Storage Solutions?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Personal Storage Services',

  cards: [
    {
      id: 1,
      title: 'Short-Term Storage',
      description:
        'Ideal for temporary situations like moving, traveling, or decluttering, our short-term storage options offer flexibility and security.',
      image: {
        src: '/images/v2/pages/common/short-term-storage.png',
        alt: 'Short-Term Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Climate-Controlled Storage',
      description:
        'For sensitive items such as electronics, antiques, or artwork, we offer climate-controlled storage to protect your belongings from extreme temperatures.',
      image: {
        src: '/images/v2/pages/common/climate-controlled-storage.png',
        alt: 'Climate-Controlled Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Long-Term Storage',
      description:
        'If you need to store items for a longer period, our long-term storage solutions provide safe and affordable options.',
      image: {
        src: '/images/v2/pages/common/long-term-storage.png',
        alt: 'Long-Term Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Packing and Moving Supplies',
      description:
        'Get all the packing materials you need to protect your items during storage, from boxes and bubble wrap to tape and labels.',
      image: {
        src: '/images/v2/pages/common/packing-and-moving-supplies.png',
        alt: 'Packing and Moving Supplies'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Personal Storage Solutions?',

  image: {
    url: '/images/v2/pages/landing-pages/personal-storage-solutions/why-choose-us-for-personal-storage-solutions.jpg',
    alt: 'Why Choose Us for Personal Storage Solutions?'
  },

  articles: [
    {
      id: 1,
      title: 'Flexible Rental Terms',
      description: 'Rent storage space for a short or long duration, with no minimum commitment.'
    },
    {
      id: 2,
      title: 'Convenient Locations',
      description:
        'Our storage facilities are located in convenient areas, so you can easily access your items whenever needed.'
    },
    {
      id: 3,
      title: 'Advanced Security',
      description:
        'Our facilities are equipped with the latest security measures, including video surveillance, alarm systems, and secure access.'
    },
    {
      id: 4,
      title: '24/7 Access',
      description:
        'Enjoy around-the-clock access to your stored items, giving you the flexibility to retrieve or store belongings at your convenience.'
    },
    {
      id: 5,
      title: 'Affordable Pricing',
      description:
        'We offer competitive pricing with no hidden fees, making personal storage solutions accessible for every budget.'
    },
    {
      id: 6,
      title: 'Expert Support',
      description:
        'Our friendly and professional staff is always available to assist with any questions or concerns you may have, ensuring a smooth experience.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Personal Storage Solutions Secure And Affordable',
  description:
    'Personal storage solutions available now. Fast, secure, and affordable options for storing your personal belongings safely.',
  image: {
    src: '/images/v2/pages/landing-pages/personal-storage-solutions/personal-storage-solutions-secure-and-affordable.png',
    alt: 'Personal Storage Solutions Secure And Affordable'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started with Personal Storage' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description: 'We collaborate with leading partners to provide top-quality storage solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx partners with us for timely delivery and pickup of your personal storage items, ensuring a seamless experience.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL supports our personal storage services by offering secure and reliable international shipping for your stored items.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS works with us to provide secure and efficient shipping services for your personal storage items, ensuring timely and safe delivery.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
